import { shallowMount } from "@vue/test-utils";
import Mancheta from "@/components/core/Mancheta";

describe("Mancheta component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Mancheta, {
      propsData: {
        text: "String"
      }
    });
  });

  it("Renders del component Mancheta", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
